<script lang="ts">
	import { Badge } from '#lib/components/ui/badge/index.js'
	import { type ChainConfig } from '#lib/constants/chainsConfig.js'
	import { m } from '#lib/paraglide/messages.js'
	import { isChainNew } from '#lib/utils/chainsHelpers.js'

	let { chain }: { chain: ChainConfig } = $props()
</script>

{#if !chain.listed}
	<Badge class="font-bold uppercase" size="4xs" variant="secondary">
		{m.menu_get_listed()}
	</Badge>
{:else if isChainNew(chain)}
	<Badge class="font-bold uppercase" size="4xs" variant="brand">New</Badge>
{/if}
